export enum UseCase {
    ALUMNI = "alumni",
}